import Cookies from "js-cookie";

/** Cargobase API tokens used for authenticated API requests after login completes. */
export const getCargobaseAuthToken = (): string | undefined =>
  Cookies.get("cargobase_logged_in_as_token") || Cookies.get("cargobase_usertoken");

/**
 * Token attached to outgoing API requests.
 * Prefer Cargobase tokens; fall back to the temporary Auth0 ID token only during /user/token exchange.
 */
const getAuthToken = (): string | undefined => getCargobaseAuthToken() || Cookies.get("auth0_id_token");

export default getAuthToken;
